import classNames from 'classnames';
import { FC, memo } from 'react';

interface iInputProps {
  value: string;
  placeholder: string;
  onChange: (val: string) => void;
  error?: string;
}

const Input: FC<iInputProps> = memo(({ value, placeholder, onChange, error }) => {
  const _handleChange = ({ target: { value } }: any) => onChange(value);

  return (
    <input
      className={classNames(error && 'error')}
      type='text'
      placeholder={placeholder}
      value={value}
      onChange={_handleChange}
    />
  );
});

export default Input;
